var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeemedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e52c28;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-arrow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2234",
    "data-name": "Group 2234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5534",
    "data-name": "Path 5534",
    className: "cls-1",
    d: "M1,.9,7,8.1,13,.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemedArrow);
export default __webpack_public_path__ + "static/media/redeemed-arrow.29802a4f6dc7724511d00d8e42017265.svg";
export { ForwardRef as ReactComponent };